/**
 * @file component.js
 * Exports component-related constants.
 */

export const COMPONENT_SELECT = 'COMPONENT_SELECT';
export const COMPONENT_TYPE_DIALOG = 'panelimage';
export const COMPONENT_TYPE_LINK = 'link';



// WEBPACK FOOTER //
// ./src/constants/component.js